import { EventEmitter } from "fbemitter";

const EMITTER = new EventEmitter();

export default EMITTER;

export enum Events {
    POPUP_OPEN = "POPUP_OPEN",
    CHANGE_WITHOUT_SCROLL = "CHANGE_WITHOUT_SCROLL",
    OPEN_MAP_POPUP = "OPEN_MAP_POPUP",
    OPEN_DROPDOWN = "OPEN_DROPDOWN",
    CLOSE_TOOLTIP = "CLOSE_TOOLTIP"
}
